module.exports = __webpack_public_path__ + "static/media/dz.60e836dc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dz.svg
// module id = 2080
// module chunks = 0